import React from "react";
import { Container } from "react-bootstrap";
import style from "../css/NotificationBox.module.css";

const NotificationBox = (props) => {
  return <Container className={style.box}>{props.children}</Container>;
};

export default NotificationBox;
